import { useObserver } from 'mobx-react';
import { useQuery, useApolloClient, NetworkStatus } from '@apollo/client';

import useUser from 'hooks/use-user';

import { filteredOrders } from 'shared/graphql/order/queries';

export default function useOrdersForConsumer() {
  const user = useUser();
  const userId = useObserver(() => user.id);
  const apolloClient = useApolloClient();

  const { data, networkStatus, loading, fetchMore } = useQuery(filteredOrders, {
    variables: {
      ordersSort: { sortBy: `createdAt`, sortDirection: `desc` },
      ordersFilter: { userId },
      ordersPagination: { limit: 5 },
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: `cache-and-network`,
    client: apolloClient,
    skip: !userId,
  });

  const { orders, queryInfo } = data?.filteredOrders || {};

  return {
    fetchMore,
    loading: loading || networkStatus === NetworkStatus.fetchMore,
    orders: orders || [],
    totalCount: queryInfo?.totalCount || 0,
  };
}

export const queryMoreOrders = (fetchMore, orders) => {
  fetchMore({
    variables: {
      ordersPagination: {
        limit: 5,
        offset: orders.length,
      },
    },
    updateQuery: (prev, { fetchMoreResult }) => {
      if (!fetchMoreResult) {
        return prev;
      }

      const { __typename, queryInfo } = fetchMoreResult.filteredOrders;

      return {
        filteredOrders: {
          __typename,
          queryInfo,
          orders: [...orders, ...fetchMoreResult.filteredOrders.orders],
        },
      };
    },
  });
};
